var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createStyles, makeStyles } from '@hawkins/styles';
export function checkboxStyles(theme) {
    var _a, _b;
    var hawkins = theme.hawkins, hawkinsUtils = theme.hawkinsUtils, hawkinsVariables = theme.hawkinsVariables;
    var checkboxDim = hawkinsVariables.sizings.size1;
    var isDarkTheme = hawkins.theme === 'dark';
    return createStyles({
        /** Class name of the element containing the fake checkbox and native `input`. */
        checkboxContainer: {
            display: 'inline-block',
            position: 'relative',
        },
        /** Class name of the element styled to look like a checkbox. */
        fakeCheckbox: {
            borderColor: hawkins.ui.borderColorLight,
            borderRadius: hawkinsVariables.borderRadius.borderRadius0,
            borderStyle: 'solid',
            borderWidth: hawkins.ui.borderWidthRegular,
            display: 'block',
            height: checkboxDim,
            position: 'relative',
            width: checkboxDim,
            zIndex: 0,
        },
        /** Class name of the fake checkbox element when it contains an icon. */
        fakeCheckboxWithIcon: {
            backgroundColor: hawkins.persistent.iconFillWhiteRegular,
            // Increase the border radius to avoid seeing the background color around the edges of the icon.
            borderRadius: '50%',
        },
        /** Class name of the selected and indeterminate icons. */
        icon: {
            color: hawkins.interactive.backgroundColorRegular,
            height: checkboxDim,
            width: checkboxDim,
            // Overlap the border of the fake checkbox.
            left: -1,
            position: 'absolute',
            top: -1,
        },
        /** Class name of the native `input` element. */
        input: (_a = {
                cursor: 'pointer',
                height: '100%',
                margin: 0,
                opacity: 0,
                position: 'absolute',
                width: '100%',
                zIndex: 1,
                top: 0,
                left: 0
            },
            _a[hawkinsUtils.getFocusRingedElementSelector('&', '~ $fakeCheckbox')] = hawkinsUtils.getFocusRingedElementStyle(undefined, __assign(__assign({}, hawkinsUtils.getFocusRingPosition(2, 1)), { borderRadius: hawkinsVariables.borderRadiusValues.borderRadius0 * 1.5 })),
            _a),
        /** Class name of the native `input` element when the component is disabled. */
        inputDisabled: {
            cursor: 'not-allowed',
            '& ~ $fakeCheckbox': { borderColor: hawkins.ui.borderColorXlight },
            '& ~ $fakeCheckboxWithIcon': {
                backgroundColor: hawkins.persistent.iconFillWhiteXlight,
                // HACK(icon), HACK(style): Can't use the `hawkins.interactive.backgroundColorDisabled` design token,
                // as it is translucent and lets the fake checkbox (which provides the white icon background) show through.
                '& $icon': { color: isDarkTheme ? '#313e6f' : '#b1beef' },
            },
        },
        /** Class name of the native `input` element when the component is not disabled. */
        inputEnabled: (_b = {},
            _b[hawkinsUtils.getHoveredElementSelector('&')] = {
                '& ~ $fakeCheckbox': {
                    borderColor: hawkins.ui.borderColorRegular,
                    '& $icon': { color: hawkins.interactive.backgroundColorHover },
                },
            },
            _b),
        /** Class name of the label. */
        label: {},
        /** Class name of the root element. */
        root: {
            alignItems: 'center',
            cursor: 'pointer',
            display: 'inline-flex',
            gap: hawkinsVariables.spacings.space1,
        },
        /** Class name of the root element when the component is disabled. */
        rootDisabled: {
            cursor: 'not-allowed',
        },
    });
}
export var useCheckboxStyles = makeStyles(checkboxStyles, { name: 'Hawkins-Checkbox' });
